import 'css-chunksrc/client/common/portfolioAssignation/styles.scss';export default {
  "portfolioAssignation": "_portfolioAssignation_3rsks_1",
  "search": "_search_3rsks_7",
  "input": "_input_3rsks_11",
  "list": "_list_3rsks_24",
  "item": "_item_3rsks_30",
  "footer": "_footer_3rsks_35",
  "addPortfolio": "_addPortfolio_3rsks_39"
};